import ListPage from "../../../manager/components/list-page/list-page";
import { IColumn } from "../../../shared/components/normal-table/normal-table";
import "./datamodel-report-configuration-list.scss";

const columns: IColumn[] = [
  {
    key: "name",
    displayName: "Name",
    dataType: {
      type: "text",
    }
  },
  {
    key: "created_at",
    displayName: "Created at",
    dataType: {
      type: "dateTime",
    }
  }
];

const DatamodelReportConfigurationList = () => {
  return (
    <div className="datamodelReportConfigurationList">
      <ListPage
        title={"Datamodel report configurations"}
        defaultSortCol={"name"}
        columns={columns}
        dataUrl={{
          url: "reports",
          backend: "platform"
        }}
        deleteUrl={{
          url: "reports",
          backend: "platform"
        }}
      />
    </div>
  );
};

export default DatamodelReportConfigurationList;